import { MILLISECONDS_IN_HOUR } from 'owa-date-constants';

export default (timestamp: number | Date, hours: number): Date =>
    new Date(+timestamp + hours * MILLISECONDS_IN_HOUR);
